import { useMemo } from "react";
import {
  getNavigationSettings,
  getStaticSettingsItems,
  type SettingsItem,
  useSettingsCategories,
  useSettingsItems,
} from "@/domains/settings/hooks/use-settings-items";
import type { CategoryInfo, SettingsSection } from "../types";

// Convert shared SettingsItem to SettingsSection for backward compatibility
const convertToSettingsSection = (item: SettingsItem): SettingsSection => ({
  id: item.id,
  title: item.title,
  icon: item.icon,
  description: item.description,
  category: item.category,
});

export const useSettingsSections = (): SettingsSection[] => {
  const allSettings = useSettingsItems();

  // Desktop excludes inline items (appearance/language render their own
  // control) AND mobileOnly items (mobile-only shortcuts to features that
  // already have their own desktop nav tab — surfacing them here would be
  // duplicate links).
  return useMemo(() => {
    const navigationSettings = getNavigationSettings(allSettings).filter(
      (item) => !item.mobileOnly
    );
    return navigationSettings.map(convertToSettingsSection);
  }, [allSettings]);
};

export const useCategoryInfo = (): Record<string, CategoryInfo> => {
  return useSettingsCategories();
};

export const getCurrentSectionFromUrl = (pathname: string): string => {
  const pathSegments = pathname.split("/");
  const sectionFromUrl = pathSegments[pathSegments.length - 1];

  const allSettings = getStaticSettingsItems();
  const validSections = allSettings.map((section) => section.id);

  if (sectionFromUrl === "settings" || !validSections.includes(sectionFromUrl)) {
    return "workers";
  }

  return sectionFromUrl;
};
